import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

export const DeviceDistributionComparisonSkeleton = () => (
    <Flex
        flex="1"
        gap="24px"
        flexDirection="column"
    >
        <PixelPlaceholderLoader
            height={45}
            width="100%"
        />
        <PixelPlaceholderLoader
            height={45}
            width="100%"
        />
    </Flex>
);
